<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 搜索 -->
        <div class="search column">
            <!-- 搜索顶部 -->
            <div class="search_top column">
                <!-- 搜索 -->
                <div class="main_search_m row" style="margin-left: 0; width: 100%;">
                    <div class="main_search_m_m row">
                        <div class="main_search_m_m_leixing" @click="clickCity">
                            <div class="zhiweileixingclass row">
                                <span>{{ cityName }}</span>
                                <i class="el-icon-caret-bottom"></i>
                            </div>
                        </div>
                        <input class="main_search_m_m_input" type="text" placeholder="搜索职位公司" v-model="sousuoVal">
                    </div>
                    <button class="main_search_m_sousuo" @click="clicksousuo">搜索</button>
                </div>
                <!-- 搜索 end -->
                <!-- 筛选条件 -->
                <div class="search_top_screen">
                    <!-- <img src="@/assets/images/shaixuantiaojian.png" alt=""> -->
                    <!-- <div>薪资待遇</div> -->
                    <div class="search_top_screen_top row">
                        <div class="search_top_screen_top_m">
                            城市和区域
                        </div>
                    </div>
                    <div class="search_top_screen_chengshi row">
                        <!-- <div class="search_top_screen_chengshi_m">
                            全国
                        </div> -->
                        <div v-for="(item, index) in clickCityArr" :key="index"
                            :class="chengshiVal == item.id ? 'search_top_screen_chengshi_m2' : 'search_top_screen_chengshi_m'"
                            @click="clickchengshi(item.id, item.name)">
                            {{ item.name }}
                        </div>
                        <div class="search_top_screen_chengshi_m" @click="clickCity">
                            其它城市
                        </div>
                    </div>
                    <div class="search_top_screen_diqu row" v-if="diquArr.length > 0">
                        <div :class="diquVal == 0 ? 'search_top_screen_diqu_m2' : 'search_top_screen_diqu_m'"
                            @click="clickdiqu(0)">
                            不限
                        </div>
                        <div v-for="(item, index) in diquArr" :key="index"
                            :class="diquVal == item.id ? 'search_top_screen_diqu_m2' : 'search_top_screen_diqu_m'"
                            @click="clickdiqu(item.id)">
                            {{ item.text }}
                        </div>
                    </div>
                    <div class="search_top_screen_tiaojian row">
                        <div class="search_top_screen_tiaojian_list row">
                            <el-cascader v-model="selectgongsihangye" :options="selectgongsihangyeList" clearable
                                :show-all-levels="false"
                                :props="{ expandTrigger: 'hover', value: 'id', label: 'industryName' }" placeholder="公司行业"
                                @change="changeselectgongsihangye" class="search_top_screen_tiaojian_list_select">
                            </el-cascader>
                            <el-cascader v-model="selectzhiweileixing" :options="selectzhiweileixingList" clearable
                                :show-all-levels="false"
                                :props="{ expandTrigger: 'hover', value: 'id', label: 'functionName' }" placeholder="职位类型"
                                @change="changeselectzhiweileixing" class="search_top_screen_tiaojian_list_select">
                            </el-cascader>
                            <el-select v-model="selectxinzidaiyu" clearable placeholder="薪资待遇"
                                @change="changeselectxinzidaiyu" class="search_top_screen_tiaojian_list_select">
                                <el-option v-for="item in selectxinzidaiyuList" :key="item.value" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="selectxueliyaoqiu" clearable placeholder="学历要求"
                                @change="changeselectxueliyaoqiu" class="search_top_screen_tiaojian_list_select">
                                <el-option v-for="item in selectxueliyaoqiuList" :key="item.value" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="selectjingyanyaoqiu" clearable placeholder="经验要求"
                                @change="changeselectjingyanyaoqiu" class="search_top_screen_tiaojian_list_select">
                                <el-option v-for="item in selectjingyanyaoqiuList" :key="item.value" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="selectgongsileixing" clearable placeholder="公司类型"
                                @change="changeselectgongsileixing" class="search_top_screen_tiaojian_list_select">
                                <el-option v-for="item in selectgongsileixingList" :key="item.value" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="selectgongsiguimo" clearable placeholder="公司规模"
                                @change="changeselectgongsiguimo" class="search_top_screen_tiaojian_list_select">
                                <el-option v-for="item in selectgongsiguimoList" :key="item.value" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>

                        </div>
                        <div class="search_top_screen_tiaojian_qingkong" @click="qingkongshaixuantiaojian">清空筛选条件</div>
                    </div>

                </div>
            </div>
            <!-- 搜索顶部 end -->
            <!-- 搜索内容 -->
            <div class="search_main row">
                <div class="search_main_l column">
                    <div class="search_main_l_list column" v-for="(item, index) in searchList" :key="index"
                        @click="clickJob(item.id)">
                        <div class="search_main_l_list_top row">
                            <div class="search_main_l_list_top_l column">
                                <div class="search_main_l_list_top_l_title row">
                                    <div class="search_main_l_list_top_l_title_l" v-if="item.name">
                                        {{ item.name }}
                                    </div>
                                    <div class="search_main_l_list_top_l_title_r row" v-if="item.workCities">
                                        <span>[</span>
                                        <div class="search_main_l_list_top_l_title_r_m">
                                            {{ item.workCities }}
                                        </div>
                                        <span>]</span>
                                    </div>
                                </div>
                                <div class="search_main_l_list_top_l_bottom row">
                                    <div class="search_main_l_list_top_l_bottom_xinzi" v-if="item.salaryType == 0">
                                        {{ item.salaryLowest }}-{{ item.salaryHighest }}k·{{ item.salaryCnt }}薪
                                    </div>
                                    <div class="search_main_l_list_top_l_bottom_xinzi" v-if="item.salaryType == 1">
                                        {{ item.salaryLowest }}-{{ item.salaryHighest }}k 年薪
                                    </div>
                                    <div class="search_main_l_list_top_l_bottom_xinzi" v-if="item.salaryType == 2">面议</div>
                                    <div class="search_main_l_list_top_l_bottom_xinzi" v-if="item.salaryType == 3">
                                        {{ item.salaryLowest }}-{{ item.salaryHighest }}元 时薪
                                    </div>
                                    <div class="search_main_l_list_top_l_bottom_xinzi" v-if="item.salaryType == 4">
                                        {{ item.salaryLowest }}-{{ item.salaryHighest }}元 日薪
                                    </div>
                                    <div class="search_main_l_list_top_l_bottom_huise" v-if="item.workYear">
                                        {{ item.workYear }}
                                    </div>
                                    <div class="search_main_l_list_top_l_bottom_huise" v-if="item.education">
                                        {{ item.education }}
                                    </div>
                                    <div class="search_main_l_list_top_l_bottom_mingzi row">
                                        <i class="el-icon-s-comment search_main_l_list_top_l_bottom_mingzi_i"></i>
                                        <span>{{ item.publisherName }} | {{ item.publisherPosition }}</span>
                                    </div>
                                    <!-- <div class="search_main_l_list_top_l_bottom_goutong row" >
                                        <i class="el-icon-s-comment search_main_l_list_top_l_bottom_goutong_i"></i>
                                        <span>立即沟通</span>
                                    </div> -->
                                    <div class="search_main_l_list_top_l_bottom_zaixian" v-if="item.onlineState == 1">
                                        <span style="font-weight: bolder;">·</span> 在线
                                    </div>
                                </div>
                            </div>
                            <div class="search_main_l_list_top_r row">
                                <img class="search_main_l_list_top_r_img" src="@/assets/images/gongsi.png" alt="">
                                <div class="search_main_l_list_top_r_r column">
                                    <div class="search_main_l_list_top_r_r_title" v-if="item.companyName">
                                        {{ item.companyName }}
                                    </div>
                                    <div class="search_main_l_list_top_r_r_bottom row">
                                        <!-- <div class="search_main_l_list_top_r_r_huise">进出口贸易</div> -->
                                        <div class="search_main_l_list_top_r_r_huise">{{ item.companyTypeText }}</div>
                                        <div class="search_main_l_list_top_r_r_huise" v-if="item.companyScaleText">
                                            {{ item.companyScaleText }}人
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="search_main_l_list_bottom row">
                            <div class="row" style="width: 460px;">
                                <div class="search_main_l_list_bottom_jineng" v-for="(ite, inde) in item.jobTags"
                                    :key="inde">
                                    <div class="search_main_l_list_bottom_jineng_m">{{ ite }}</div>
                                </div>
                            </div>
                            <div class="search_main_l_list_bottom_fuli" v-for="(ite, inde) in item.highlights" :key="inde">
                                <div class="search_main_l_list_bottom_fuli_m">{{ ite }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="search_main_l_fenye" v-if="searchList.length > 0">
                        <el-pagination background layout="prev, pager, next" :total="total"
                            @current-change="fenye"></el-pagination>
                    </div>
                    <div class="search_main_l_fenye" v-else>
                        暂无数据，请重新搜索
                    </div>
                    <!-- <div class="search_main_l_dibu">
                        <div class="search_main_l_dibu_m">
                            <img src="@/assets/images/sousuodibu.png" alt="">
                        </div>
                    </div> -->
                </div>
                <div class="search_main_r column">
                    <!-- <div class="search_main_r_jianlimoban">
                        <div class="search_main_r_jianlimoban_anniu">简历模板</div>
                    </div> -->
                    <!-- <div class="search_main_r_kanguodezhiwei column">
                        <div class="search_main_r_kanguodezhiwei_top">看过的职位</div>
                        <div class="search_main_r_kanguodezhiwei_main">
                            <img src="@/assets/images/kanguodezhiwei.png" alt="">
                        </div>
                    </div> -->
                    <div class="search_main_r_guanggao">
                        <a>
                            <img src="@/assets/images/guanggao1.png" alt="">
                        </a>
                    </div>
                    <div class="search_main_r_guanggao">
                        <a>
                            <img src="@/assets/images/guanggao2.png" alt="">
                        </a>
                    </div>
                    <div class="search_main_r_guanggao">
                        <a>
                            <img src="@/assets/images/guanggao3.jpg" alt="">
                        </a>
                    </div>
                </div>
            </div>
            <!-- 搜索内容 end -->
        </div>
        <!-- 底部 -->
        <Footer></Footer>
        <!-- 其他城市弹窗 -->
        <DialogCity v-if="dialogCityVisible" @clickCity="clickDialogCity"></DialogCity>
    </div>
</template>

<script>
import DialogCity from '@/components/DialogCity.vue'
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'
import { CityHotList } from "@/api/data/city.js";


export default {
    name: 'LaSearch',
    components: { NavTop, Footer, DialogCity },
    data() {
        return {
            total: 0,
            params: {
                page: 1,
                pageSize: 10,
                salaryRange: '', // 月薪范围
                sortRule: 0, // 排序规则：0:最新，1:推荐
                keyword: '', // 关键词
                experience: '', // 经验
                education: '', // 学历
                customerScale: '', // 公司规模
                province: '', // 省份或直辖市
                city: '', // 城市
                functionId: '',  // 职能id
                industryId: '',  // 行业id
            },
            sousuoVal: '',
            cityName: '全国',
            searchList: [],
            chengshiVal: 0,
            clickCityArr: [],
            diquVal: 0,
            diquArr: [],
            selectgongsihangye: '',
            selectgongsihangyeList: [],
            selectzhiweileixing: '',
            selectzhiweileixingList: [],
            selectxinzidaiyu: '',
            selectxinzidaiyuList: [],
            selectxueliyaoqiu: '',
            selectxueliyaoqiuList: [],
            selectjingyanyaoqiu: '',
            selectjingyanyaoqiuList: [],
            selectgongsileixing: '',
            selectgongsileixingList: [],
            selectgongsiguimo: '',
            selectgongsiguimoList: [],
            dialogCityVisible: false,


        }
    },
    // watch: {
    //     // 监听路由变化
    //     '$route': {
    //         immediate: true,
    //         handler(params) {
    //             console.log('params-->', params);
    //             if (params.query.keyword) {
    //                 this.params.keyword = params.query.keyword;
    //             }
    //             this.getPositionList();
    //         }
    //     }
    // },
    mounted() {
        this.clickCityArr = CityHotList;
    },
    activated() {
        if (this.$route.query.keyword) {
            this.params.keyword = this.$route.query.keyword;
            this.sousuoVal = this.$route.query.keyword;
        } else {
            this.sousuoVal = '';
        }
        // if (this.$route.query.position) {
        //     this.params.functionId = this.$route.query.position;
        //     this.selectzhiweileixing = this.$route.query.position;
        // }
        console.log('this.$route.params.keyword-->', this.$route.query.keyword);
        // 获取所有行业
        this.getSystemIndustry();
        // 获取职位类型
        this.getSystemFunctions();
        // 获取条件筛选
        this.getJobConditions();
        // 获取城市列表
        this.getSystemAreas();

        // 获取列表
        this.getPositionList();
    },
    methods: {
        clickJob(id) {
            this.$router.push('/jobdetail/' + id);
        },
        // 获取列表
        async getPositionList() {
            this.searchList = [];
            let res = await this.$API.getJobListApi(this.params);
            console.log('获取列表-->', res);
            if (res.code == 0) {
                this.searchList = res.data.records;
                this.total = res.data.total;
            }
        },
        // 获取所有行业
        async getSystemIndustry() {
            let res = await this.$API.getSystemIndustryApi();
            console.log('获取所有行业-->', res);
            let arr = this.handleTreeList(res.data);
            this.selectgongsihangyeList = arr;
        },
        // 获取职位类型
        async getSystemFunctions() {
            let res = await this.$API.getSystemFunctionsApi();
            console.log('获取职位类型-->', res);
            let arr = this.handleTreeList(res.data);
            this.selectzhiweileixingList = arr;
        },
        // 删除第三级children
        handleTreeList(list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].children.length < 1) {  // 判断children的数组长度
                    list[i].children = undefined
                } else {
                    this.handleTreeList(list[i].children)
                }
            }
            return list
        },
        // 获取城市列表
        async getSystemAreas() {
            let res = await this.$API.getSystemAreasApi();
            console.log('获取城市列表-->', res);
        },
        // 获取条件筛选
        async getJobConditions() {
            let res = await this.$API.getJobConditionsApi();
            console.log('获取条件筛选-->', res);
            this.selectxinzidaiyuList = res.data[0].value;
            this.selectxueliyaoqiuList = res.data[1].value;
            this.selectjingyanyaoqiuList = res.data[2].value;
            this.selectgongsileixingList = res.data[3].value;
            this.selectgongsiguimoList = res.data[4].value;

        },
        // 清空筛选条件
        qingkongshaixuantiaojian() {
            this.selectgongsihangye = '';
            this.selectzhiweileixing = '';
            this.selectxinzidaiyu = '';
            this.selectxueliyaoqiu = '';
            this.selectjingyanyaoqiu = '';
            this.selectgongsileixing = '';
            this.selectgongsiguimo = '';
            this.params.salaryRange = '';
            this.params.education = '';
            this.params.experience = '';
            this.params.companyType = '';
            this.params.companyScale = '';
            // 获取列表
            this.getPositionList();
        },
        // 选择城市
        clickchengshi(val, name) {
            console.log('选择城市-->', val);
            this.cityName = name;
            this.chengshiVal = val;
            this.diquArr = [];
            if (val != 0) {
                this.params.city = val;
                this.systemAreaId(val);
            } else {
                this.params.city = '';
                // 获取列表
                this.getPositionList();
            }
        },
        async systemAreaId(val) {
            if (val != 0) {
                // 获取子地区
                let res = await this.$API.getSystemAreaIdApi(val);
                console.log('获取子地区-->', res);
                this.diquArr = res.data;
                // 获取列表
                this.getPositionList();
            } else {
                this.params.city = '';
                // 获取列表
                this.getPositionList();
            }
        },
        // 选择地区
        async clickdiqu(val) {
            console.log('选择地区-->', val);
            this.diquVal = val;
            if (val != 0) {
                this.params.city = val;
                // 获取列表
                this.getPositionList();
            } else {
                this.params.city = this.chengshiVal;
                // 获取列表
                this.getPositionList();
            }
        },
        // 点击其他城市
        clickCity() {
            this.dialogCityVisible = true;
            console.log('点击其他城市-->', this.dialogCityVisible);

        },
        // 获取点击其他城市
        clickDialogCity(val) {
            console.log('获取点击其他城市-->', val);
            this.dialogCityVisible = val.state;
            if (val.city.name) {
                this.cityName = val.city.name;
                this.chengshiVal = val.city.id;
                this.params.city = val.city.id;
                this.systemAreaId(val.city.id);

            }
        },
        // 点击所有行业
        changeselectgongsihangye(val) {
            console.log('点击所有行业-->', val);
            this.params.industryId = val[0];
            // 获取列表
            this.getPositionList();
        },
        // 点击职位类型
        changeselectzhiweileixing(val) {
            console.log('点击职位类型-->', val);
            this.params.functionId = val[val.length - 1];
            console.log('点击职位类型-->', this.params.functionId);
            console.log('点击职位类型-->', this.selectzhiweileixing);

            // 获取列表
            this.getPositionList();
        },
        // 点击薪资待遇
        changeselectxinzidaiyu(val) {
            console.log('点击薪资待遇-->', val);
            this.params.salaryRange = val;
            // 获取列表
            this.getPositionList();
        },
        // 点击学历要求
        changeselectxueliyaoqiu(val) {
            console.log('点击学历要求-->', val);
            this.params.education = val;
            // 获取列表
            this.getPositionList();
        },
        // 点击经验要求
        changeselectjingyanyaoqiu(val) {
            console.log('点击经验要求-->', val);
            this.params.experience = val;
            // 获取列表
            this.getPositionList();
        },
        // 点击公司类型
        changeselectgongsileixing(val) {
            console.log('点击公司类型-->', val);
            this.params.companyType = val;
            // 获取列表
            this.getPositionList();
        },
        // 点击公司规模
        changeselectgongsiguimo(val) {
            console.log('点击公司规模-->', val);
            this.params.companyScale = val;
            // 获取列表
            this.getPositionList();
        },
        // 搜索按钮
        clicksousuo() {
            console.log('搜索按钮-->', this.sousuoVal);
            this.params.keyword = this.sousuoVal;
            this.getPositionList();
        },






        // 分页
        fenye(e) {
            console.log('分页-->', e);
            this.params.page = e;
            this.getPositionList();
        }
    }

}
</script>

<style scoped>
.search {
    width: 100%;
    height: auto;
}

.search_top {
    width: 1160px;
    height: auto;
    margin: 20px auto 20px;
    background: #fff;
    border-radius: 10px;
    padding: 20px;
}

.search_top_screen {
    margin-top: 20px;
}


.search_main {
    width: 1200px;
    height: auto;
    margin: auto;
    justify-content: space-between;
}

.search_main_l {
    width: 900px;
    height: auto;
}

.search_main_l_list {
    width: 100%;
    height: auto;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 20px;
    cursor: pointer;
}

.search_main_l_list:hover {
    box-shadow: 0 16px 40px 0 hsla(0, 0%, 60%, .3);
    z-index: 3;
}

.search_main_l_list:hover .search_main_l_list_top_l_bottom_mingzi {
    /* display: none; */
}

.search_main_l_list:hover .search_main_l_list_top_l_bottom_goutong {
    display: flex;
}

.search_main_l_list:hover .search_main_l_list_top_l_title {
    color: #00b277;
}

.search_main_l_list_top {
    width: 100%;
    height: auto;
    background: #fff;
    justify-content: space-between;
}

.search_main_l_list_top_l {
    padding: 15px 20px;
}

.search_main_l_list_top_l_title {
    font-weight: 500;
    color: #222;
    line-height: 22px;
    max-width: 460px;
}

.search_main_l_list_top_l_title_l {
    font-size: 16px;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.search_main_l_list_top_l_title_r {
    max-width: 214px;
    margin-left: 12px;
    line-height: 22px;
}

.search_main_l_list_top_l_title_r_m {
    font-size: 16px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.search_main_l_list_top_l_bottom {
    margin-top: 12px;
    height: 22px;
}

.search_main_l_list_top_l_bottom_xinzi {
    font-size: 16px;
    font-weight: 500;
    color: #fe574a;
    line-height: 22px;
}

.search_main_l_list_top_l_bottom_huise {
    margin-left: 8px;
    padding: 2px 8px;
    background: #f8f8f8;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 400;
    color: #666;
    line-height: 18px;
}

.search_main_l_list_top_l_bottom_mingzi {
    margin-left: 8px;
    padding: 1px 8px 1px 8px;
    float: left;
    max-width: 168px;
    border-radius: 4px;
    border: 1px solid #e5e6e6;
    line-height: 17px;
    font-size: 12px;
    color: #666;
    align-items: center;
}

.search_main_l_list_top_l_bottom_mingzi span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.search_main_l_list_top_l_bottom_mingzi_i {
    color: #00b277;
    font-size: 16px;
    margin: 2px 5px 0 0;
}

.search_main_l_list_top_l_bottom_goutong {
    display: none;
    background: #00b277;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
    line-height: 17px;
    padding: 1px 8px 1px 8px;
    margin-left: 8px;
    align-items: center;
}

.search_main_l_list_top_l_bottom_goutong_i {
    color: #fff;
    font-size: 16px;
    margin: 2px 5px 0 0;
}

.search_main_l_list_top_l_bottom_zaixian {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 20px;
    display: inline-block;
    position: relative;
    height: 20px;
    background: #d8f9e5;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    color: #1dc165;
    line-height: 20px;
    padding: 1px 0px 1px 8px;
    margin-left: 8px;
    width: 45px;
}

.search_main_l_list_top_r {
    width: 300px;
    padding: 15px 20px;
}

.search_main_l_list_top_r_img {
    width: 56px;
    height: 56px;
    border-radius: 8px;
    border: 1px solid #f8f8f8;
}

.search_main_l_list_top_r_r {
    margin-left: 12px;
}

.search_main_l_list_top_r_r_title {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    height: 22px;
    color: #222;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
}

.search_main_l_list_top_r_r_bottom {
    margin-top: 12px;
    height: 22px;
    max-width: 298px;
}

.search_main_l_list_top_r_r_huise {
    margin-right: 8px;
    background: #f8f8f8;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 400;
    color: #666;
    line-height: 18px;
}

.search_main_l_list_bottom {
    width: calc(100% - 30px);
    padding: 15px 20px 15px 10px;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    justify-content: space-between;
}

.search_main_l_list_bottom_jineng {
    width: 520px;
    height: 18px;
    overflow: hidden;

}

.search_main_l_list_bottom_jineng_m {
    display: inline-block;
    position: relative;
    padding: 0 8px;
    font-size: 13px;
    font-weight: 400;
    color: #666;
    line-height: 18px;
    white-space: nowrap;
}

.search_main_l_list_bottom_fuli {
    width: 302px;
    font-size: 13px;
    font-weight: 400;
    color: #666;
    line-height: 18px;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    float: right;
}

.search_main_l_list_bottom_fuli_m {
    display: inline-block;
    position: relative;
    padding: 0 8px;
    font-size: 13px;
    font-weight: 400;
    color: #666;
    line-height: 18px;
    white-space: nowrap;
}

.search_main_l_fenye {
    width: 100%;
    height: auto;
    margin: 10px auto 40px;
    text-align: center;
}

.search_main_l_dibu {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
}

.search_main_l_dibu_m {
    padding: 20px;
}

.search_main_r {
    width: 280px;
    height: auto;
}

.search_main_r_jianlimoban {
    width: 100%;
    height: 66px;
    border-radius: 10px;
    background: #fff url('@/assets/images/jianlimoban_bg.png') 0/100% auto no-repeat;
}

.search_main_r_jianlimoban_anniu {
    width: 176px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    color: #fff;
    font-weight: 500;
    font-size: 15px;
    margin: 16px auto 0;
    background: linear-gradient(90deg, #05d9d6, #00b277);
    box-shadow: 0 5px 10px -5px rgba(16, 139, 140, .6);
    border-radius: 8px;
    cursor: pointer;
}

.search_main_r_kanguodezhiwei {
    width: 100%;
    height: auto;
    border-radius: 10px;
    /* margin-top: 20px; */
    background: #fff;
}

.search_main_r_kanguodezhiwei_top {
    height: 23px;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    border-radius: 12px 12px 0 0;
    font-size: 16px;
    font-weight: 500;
    color: #222;
    line-height: 22px;
    padding: 12px 24px;
}

.search_main_r_kanguodezhiwei_main {
    padding: 20px;
}


.search_main_r_guanggao {
    width: 100%;
    height: auto;
    overflow: hidden;
    border-radius: 10px;
    margin-bottom: 20px;
}

.search_main_r_guanggao img {
    width: 100%;
}

.search_top_screen_top {
    margin-bottom: 8px;
}

.search_top_screen_top_m {
    color: #00b277;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    float: left;
    cursor: pointer;
    padding-bottom: 6px;
    transition: all .2s linear;
    border-bottom: 3px solid #00b277;
    border-radius: 2px;
}

.search_top_screen_chengshi {
    margin: 18px 2px 0;
}

.search_top_screen_chengshi_m {
    white-space: nowrap;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 20px;
    cursor: pointer;
    margin: 0 10px 10px;
}

.search_top_screen_chengshi_m:hover {
    color: #00b277;
    font-weight: 500;
}

.search_top_screen_chengshi_m2 {
    white-space: nowrap;
    font-size: 14px;
    color: #00b277;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    margin: 0 10px 10px;
}

.search_top_screen_diqu {
    background: #f8f8f8;
    padding: 10px 12px 0 0;
    border-radius: 4px;
    margin-top: 5px;
    flex-wrap: wrap;
}

.search_top_screen_diqu_m {
    white-space: nowrap;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 20px;
    cursor: pointer;
    margin: 0 10px 10px;
}

.search_top_screen_diqu_m:hover {
    color: #00b277;
    font-weight: 500;
}

.search_top_screen_diqu_m2 {
    white-space: nowrap;
    font-size: 14px;
    color: #00b277;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    margin: 0 10px 10px;
}

.search_top_screen_tiaojian {
    margin-top: 20px;
    align-items: center;
    justify-content: space-between;
}

.search_top_screen_tiaojian_list {}

.search_top_screen_tiaojian_list_select {
    width: 120px;
    margin-right: 20px;
}

.search_top_screen_tiaojian_qingkong {
    font-size: 14px;
    font-weight: 400;
    color: #999;
    line-height: 20px;
    cursor: pointer;
}

.search_top_screen_tiaojian_qingkong:hover {
    color: #00b277;
}
</style>
